import { Directive, Injector, Input } from '@angular/core';
import { BaseControlDirective } from './base-control.directive';

@Directive()
export abstract class CommonDropdownControlDirective<TItem, TValue> extends BaseControlDirective<TValue> {
  @Input() public placeholder = '';
  @Input() public disabled = false;
  @Input() public testId = '';
  @Input() public items!: TItem[];
  @Input() public getName!: (item: TItem) => string | undefined;
  @Input() public getValue: (item: TItem) => TValue = item => item as unknown as TValue;

  private selectedItemField: TItem | undefined;
  public get selectedItem(): TItem | undefined {
    return this.selectedItemField;
  }

  public constructor(injector: Injector) {
    super(injector);
  }

  public onItemClick(item: TItem): void {
    this.writeValue(this.getValue(item));
  }

  public modelChanged(): void {
    super.modelChanged();
    if (this.items) {
      this.selectedItemField = this.items.find(item => this.getValue(item) === this.model);
    }
  }

  public resolveName(item: TItem | unknown): string {
    return item ? this.getName(item as TItem) ?? '' : this.placeholder;
  }
}
